import React, { Component } from 'react'
import { Button, Pagination, Radio } from 'antd'
import { _convertObject } from "../../../helpers/convertObject"
import BatchProductionStatusTable from './table/BatchProductionStatusTable'
import BatchProductionStatusPageFilters from './filters/BatchProductionStatusPageFilters'
import { listBatchesV4 } from "../../../services/api/3dApi"
import { getListBrand, getListMaterial } from '../../../services/api/3dApi'
import store from 'store'

class BatchProductionStatusPage extends Component {
    storeName = 'BatchProductionStatusFilter'
    checkStoreValue = (field, value) => {
        return store.get(this.storeName) !== undefined ? store.get(this.storeName)[field] : value
    }
    state = {
        batches: [],
        total: 0,
        limit: 100,
        page: 1,
        loading: false,
        error: '',
        filters: {
            name: '',
            partner: [],
            mutiple_sewing_partner: [],
            sewing_partner: '',
            level: '',
            overTimeIn: '',
            overTimeEp: '',
            product_types: [],
            user_create: '',
            status: this.checkStoreValue('status', 'wait_to_print'),
            batch_overtime: [],
            materials: [],
            received_laser_user: [],
            laser_cutter_name: [],
            production_partner: [],
        },
        listBrand: [],
        listMaterials: [],
        showFilters: this.checkStoreValue('showFilters', false),
        total_items_without_moved: 0,
        total_items_without_moved_and_completed: 0,
        total_items_overtime_produce: 0,
        total_items_not_shipped: 0,
        isShowSewingPartner: false
    }

    componentDidMount() {
        const { typeOverTime } = this.props
        const { filters, showFilters } = this.state

        const objOvertime = typeOverTime !== undefined && this._convertOvevetime(typeOverTime)
        if (store.get('BatchProductionStatusFilter') === undefined) {
            store.set('BatchProductionStatusFilter', {
                status: filters.status,
                showFilters,
            })
        }
        this._getListBrand()
        this._fetchListMaterials()
        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                    ...objOvertime,
                    status: filters.status ? filters.status : 'wait_to_print'
                },
                page: 1
            }
        }, this._fetchBatches)
        this.timer = setInterval(
            () => this.setState(({ filters }) => {
                return {
                    filters: {
                        ...filters,
                        ...objOvertime,
                        status: filters.status ? filters.status : 'wait_to_print'
                    },
                    page: 1
                }
            }, this._fetchBatches),
            60000,
        );
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    _handleUpdateStorage = (params) => {
        const storage = store.get('BatchProductionStatusFilter')

        store.set('BatchProductionStatusFilter', {
            ...storage,
            ...params
        })
    }

    _convertOvevetime = (field) => {
        return {
            [field]: { from: 0, phase_status: "not_completed" },
        }
    }

    _fetchBatches = async () => {
        const { requestCount } = this.state
        const nextCount = requestCount ? requestCount + 1 : 1

        this.setState({
            loading: true,
            requestCount: nextCount
        })

        try {
            const { limit, page, filters, listMaterials } = this.state
            const { production_process, embroidery_batch_statistic, designed_at = {}, ...restFilters } = Object.assign({}, filters)
            let sewing_time = ''
            if (filters.hasOwnProperty('sewing_time_type')) {
                switch (filters.sewing_time_type) {
                    case 'received_1d':
                        sewing_time = { from: 0, to: 24 }
                        break
                    case 'received_2d':
                        sewing_time = { from: 24, to: 48 }
                        break
                    case 'received_3d':
                        sewing_time = { from: 48, to: 72 }
                        break
                    case 'received_4d':
                        sewing_time = { from: 72 }
                        break
                    case 'not_received':
                        sewing_time = 'not_received'
                        break
                    default:
                        sewing_time = ''
                }
            }

            let arrMaterial = []
            if (!!restFilters.materials && Array.isArray(restFilters.materials) && restFilters.materials.length) {
                restFilters.materials.forEach(item => {
                    const material = listMaterials.find(i => i.name === item) || {}
                    const code = !!material.code ? material.code : ''
                    arrMaterial.push(`${code} - ${item}`)
                })

                arrMaterial.push(...restFilters.materials)
            } else {
                !!restFilters.materials && restFilters.materials.length && arrMaterial.push(restFilters.materials)
            }

            let payload = {
                ...filters,
                limit,
                sewing_time,
                page: page,
                product_types: filters.product_types,
                without_partner: ['a', 'CF'],
                "sort": {
                    "custom_max_overtime": -1,
                    "created_at": 1,
                },
                sewed: 'all'
            }

            if(!!arrMaterial && arrMaterial.length) payload.materials = arrMaterial

            if (!!filters.name && filters.name.length > 0 && filters.name[0] !== '') {
                payload = Object.assign(payload, { name: { '$in': filters.name } })
            }
            if(!!production_process){
                payload.production_process = production_process
                if(embroidery_batch_statistic) payload.embroidery_batch_statistic = embroidery_batch_statistic
                if(!!Object.keys(designed_at).length) payload.designed_at = {
                    from: designed_at.from,
                    to: designed_at.to
                }
            }

            const newFilter = _convertObject(payload)

            const { data: response } = await listBatchesV4(newFilter)
            const { data, success, error } = response

            if (nextCount !== this.state.requestCount) {
                return
            }

            if (!success) {
                this.setState({
                    error: error,
                    loading: false
                })
            }

            const { batches, total, total_items_without_moved, total_items_without_moved_and_completed, total_items_overtime_produce, total_items_not_shipped } = { ...data }

            this.setState({
                batches: batches || [],
                total,
                loading: false,
                error: '',
                total_items_without_moved,
                total_items_without_moved_and_completed,
                total_items_overtime_produce,
                total_items_not_shipped
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _getListBrand = async () => {
        const payload = {
            limit: 10000,
            page: 1
        }
        try {
            const { data: Data } = await getListBrand(payload)
            const { data, success, message } = Data
            const Brands = data.Brands.map(i => ({ value: i.name, label: i.name }))
            if (success) {
                this.setState({ ...this.state, listBrand: Brands })
            } else {
                console.log(message)
            }
        } catch (error) {
            console.log(error)
        }
    }

    _handleChangeInput = (field, value) => {
        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                    [field]: value
                },
                page: 1
            }
        }, () => {
            this._fetchBatches()
            field === 'status' && this._handleUpdateStorage({ [field]: value })
        })
    }

    _handleChangeInputNew = (filter) => {
        this.setState(({ filters }) => {
            return {
                filters: {
                    ...filters,
                    ...filter
                },
                page: 1
            }
        }, () => {
            this._fetchBatches()
            Object.keys(filter).includes('status') && this._handleUpdateStorage({ ...filter })
        })
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1
        }, this._fetchBatches)
    }

    _handleChangeProductType = (value) => {
        const { filters } = this.state

        this.setState({
            filters: {
                ...filters,
                product_types: value
            },
            page: 1
        }, this._fetchBatches)
    }

    _handleChangeDate = (filters) => {
        this.setState({
            filters: {
                ...filters,
            },
            page: 1
        }, this._fetchBatches)
    }

    _handlePageChange = (page) => {
        this.setState({
            page: page
        }, this._fetchBatches)
    }

    _handleToggleFilters = () => {
        const { showFilters } = this.state
        this.setState({ showFilters: !showFilters }, this._handleUpdateStorage({ showFilters: !showFilters }))
    }

    _fetchListMaterials = async () => {
        try {

            const { data: res } = await getListMaterial({ limit: 10000 })
            const { data, success, message } = res
            if (!success) {
                return this.setState({
                    error: message
                })
            }

            this.setState({
                listMaterials: data.data || []
            })
        } catch (error) {
            this.setState({
                error: error.message
            })
        }
    }

    _handleChangeMaterials = (value) => {
        const { filters } = this.state
        this.setState({
            filters: {
                ...filters,
                materials: value
            },
            page: 1
        }, this._fetchBatches)
    }

    _handleChangeCheckBox = (checked) => {
        this.setState({
            isShowSewingPartner: !checked
        })
    }

    render() {
        const { batches, error, page, total, limit, loading, filters, listBrand, showFilters, total_items_without_moved, total_items_without_moved_and_completed, total_items_overtime_produce, total_items_not_shipped, listMaterials = [], isShowSewingPartner = false } = this.state
        const newFilter = _convertObject(filters)

        let total_items = 0
        if (!!newFilter.status && ['sewing_with_receive, embroidered', 'wait_to_sew_with_cut_laze, sewing_without_receive'].includes(newFilter.status)) {
            total_items = total_items_without_moved_and_completed
        } else if (newFilter.status === 'completed_without_shipped') {
            total_items = total_items_not_shipped
        } else {
            total_items = total_items_without_moved
        }

        const newBatches = isShowSewingPartner ? batches.filter(i => {
            const { sewing_partner = {} } = Object.assign({}, i)
            const { has_groups = false } = Object.assign({}, sewing_partner)
            return !!has_groups
        }) : batches

        return (
            <div className='LabelPage BatchProductionStatusPage'>
                <div className='container-fluid min-vh-100'>
                    <div className='col-12 mx-auto bg-white shadow-sm py-3'>
                        <div className="">
                            <div
                                className="jumbotron px-3 pb-0 pt-3 mb-3"
                                style={(!showFilters ? { display: 'none' } : {})}
                            >
                                <BatchProductionStatusPageFilters
                                    filters={filters}
                                    loading={loading}
                                    listBrand={listBrand}
                                    listMaterials={listMaterials}
                                    handleChangeInput={this._handleChangeInput}
                                    handleChangeDate={this._handleChangeDate}
                                    onChangeProductType={this._handleChangeProductType}
                                    onChangeInputNew={this._handleChangeInputNew}
                                    onChangeMaterials={this._handleChangeMaterials}
                                    isShowSewingPartner={isShowSewingPartner}
                                    isSewingGroup={filters.without_sewing_group}
                                    onChangeCheckBox={this._handleChangeCheckBox}
                                    {...this.props}
                                />
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                                <div>
                                    <Radio.Group
                                        field='status'
                                        defaultValue={filters.status || 'wait_to_print'}
                                        buttonStyle="solid"
                                        size="large"
                                        onChange={(e) => this._handleChangeInput('status', e.target.value)}
                                    >
                                        <Radio.Button value={'wait_to_print'}>IN</Radio.Button>
                                        <Radio.Button value={'wait_to_transferred'}>ÉP</Radio.Button>
                                        <Radio.Button value={'transferred'}>QC SAU ÉP</Radio.Button>
                                        <Radio.Button value={'wait_to_sew_without_cut_laze'}>LAZE</Radio.Button>
                                        <Radio.Button value={'wait_to_mex'}>ÉP MEX </Radio.Button>
                                        <Radio.Button value={'wait_to_sew_with_cut_laze'}>CHỜ MAY</Radio.Button>
                                        <Radio.Button value={'sewing_without_receive'}>MAY</Radio.Button>
                                        <Radio.Button value={'sewed'}>HOÀN THIỆN</Radio.Button>
                                        <Radio.Button value={'sewing_with_receive, embroidered'}>QC HOÀN THÀNH</Radio.Button>
                                        <Radio.Button value={'completed_without_shipped'}>CHỜ SHIP</Radio.Button>
                                    </Radio.Group>
                                </div>

                                <div className='d-flex justify-content-between align-items-center'>
                                    <Pagination current={page} total={total} pageSize={limit}
                                        showTotal={(sum, range) => sum > 0 &&
                                            <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng (Total: ${total_items} items`}{newFilter.status === 'completed_without_shipped' ? `, Quá hạn: ${total_items_overtime_produce} items)` : ')'}</strong>
                                            </div>}
                                        onChange={this._handlePageChange}
                                        className='text-right mr-3'
                                        pageSizeOptions={['10', '20', '50', '100', '200']}
                                        onShowSizeChange={this._handleShowSizeChange} />
                                    <Button onClick={this._handleToggleFilters}>
                                        {showFilters ? 'Ẩn Lọc' : 'Lọc'}
                                    </Button>
                                </div>

                            </div>
                            <div>
                                {error && (
                                    <div className="text-danger mb-2">{error}</div>
                                )}
                            </div>
                            <BatchProductionStatusTable
                                newFilter={newFilter}
                                batches={newBatches}
                                loading={loading}
                                refreshBatches={this._fetchBatches}
                                onChangeProductType={this._handleChangeProductType}
                                handleChangeInput={this._handleChangeInput}
                                total_items_without_moved={total_items_without_moved}
                                total_items_without_moved_and_completed={total_items_without_moved_and_completed}
                                total_items_not_shipped={total_items_not_shipped}
                            />
                            <Pagination
                                current={page} total={total} pageSize={limit}
                                onChange={this._handlePageChange}
                                showQuickJumper
                                className='CustomPagination text-right'
                                pageSizeOptions={['10', '20', '50', '100', '200']}
                                onShowSizeChange={this._handleShowSizeChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default BatchProductionStatusPage
